export default function effectsMiddleware(effects) {
    return ({ getState, dispatch }) => next => action => {
        const previousState = getState();
        const returnValue = next(action);
        const nextState = getState();
        effects(previousState, nextState, dispatch, action);
        return returnValue;
    };
}
